/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionsList } from "../funcs/remoteSessionsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import {
  ListRemoteSessionsRequest,
  ListRemoteSessionsResponse,
  ListRemoteSessionsSecurity,
} from "../models/operations/listremotesessions.js";
import { unwrapAsync } from "../types/fp.js";
import { PageIterator, unwrapResultIterator } from "../types/operations.js";
import { pageIteratorToJSON } from "./_types.js";
export type RemoteSessionsQueryData = ListRemoteSessionsResponse;

export type RemoteSessionsInfiniteQueryData = PageIterator<
  ListRemoteSessionsResponse,
  { cursor: string }
>;

export type RemoteSessionsPageParams = PageIterator<
  ListRemoteSessionsResponse,
  { cursor: string }
>["~next"];

export function prefetchRemoteSessions(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRemoteSessionsRequest | undefined,
  security?: ListRemoteSessionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRemoteSessionsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function prefetchRemoteSessionsInfinite(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListRemoteSessionsRequest | undefined,
  security?: ListRemoteSessionsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchInfiniteQuery({
    ...buildRemoteSessionsInfiniteQuery(
      client$,
      request,
      security,
      options,
    ),
    initialPageParam: undefined as RemoteSessionsPageParams,
    getNextPageParam: (previousPage: RemoteSessionsInfiniteQueryData) =>
      previousPage["~next"],
  });
}

export function buildRemoteSessionsQuery(
  client$: GramCore,
  request?: ListRemoteSessionsRequest | undefined,
  security?: ListRemoteSessionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<RemoteSessionsQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessions({
      principalId: request?.principalId,
      userSessionIssuerId: request?.userSessionIssuerId,
      subjectUrn: request?.subjectUrn,
      remoteSessionClientId: request?.remoteSessionClientId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function remoteSessionsQueryFn(
      ctx,
    ): Promise<RemoteSessionsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function buildRemoteSessionsInfiniteQuery(
  client$: GramCore,
  request?: ListRemoteSessionsRequest | undefined,
  security?: ListRemoteSessionsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext<QueryKey, RemoteSessionsPageParams>,
  ) => Promise<RemoteSessionsInfiniteQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessionsInfinite({
      principalId: request?.principalId,
      userSessionIssuerId: request?.userSessionIssuerId,
      subjectUrn: request?.subjectUrn,
      remoteSessionClientId: request?.remoteSessionClientId,
      cursor: request?.cursor,
      limit: request?.limit,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function remoteSessionsQuery(
      ctx,
    ): Promise<RemoteSessionsInfiniteQueryData> {
      const sig = combineSignals(ctx.signal, options?.fetchOptions?.signal);
      const mergedOptions = {
        ...options,
        fetchOptions: { ...options?.fetchOptions, signal: sig },
      };

      if (!ctx.pageParam) {
        const pageResult = await unwrapResultIterator(remoteSessionsList(
          client$,
          request,
          security,
          mergedOptions,
        ));
        return pageIteratorToJSON(pageResult);
      }
      const pageResult = await unwrapResultIterator(remoteSessionsList(
        client$,
        {
          ...request!,
          cursor: ctx.pageParam.cursor,
        },
        security,
        mergedOptions,
      ));
      return pageIteratorToJSON(pageResult);
    },
  };
}

export function queryKeyRemoteSessions(
  parameters: {
    principalId?: string | undefined;
    userSessionIssuerId?: string | undefined;
    subjectUrn?: string | undefined;
    remoteSessionClientId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteSessions", "list", parameters];
}

export function queryKeyRemoteSessionsInfinite(
  parameters: {
    principalId?: string | undefined;
    userSessionIssuerId?: string | undefined;
    subjectUrn?: string | undefined;
    remoteSessionClientId?: string | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteSessions", "list", "infinite", parameters];
}
